import { Component, OnInit } from '@angular/core';
import { UsersService } from 'src/app/Services/users.service';
import { CustomToasterServiceService } from 'src/app/Services/custom-toaster-service.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

  activeTab: 'Tourguide' | 'Tourist' = 'Tourguide';
  isLoading: boolean = false;
  isSaving: boolean = false;

  originalData: any = {
    adminEmail: '',
    adminPhone: '',
    aboutText: ''
  };

  currentData: any = {
    adminEmail: '',
    adminPhone: '',
    aboutText: ''
  };

  constructor(
    private usersService: UsersService,
    private toasterService: CustomToasterServiceService
  ) {}

  ngOnInit(): void {
    this.loadAppSettings(this.activeTab);
  }

  switchTab(tab: 'Tourguide' | 'Tourist') {
    if (this.activeTab === tab) return;
    this.activeTab = tab;
    this.loadAppSettings(tab);
  }

  loadAppSettings(appType: string) {
    this.isLoading = true;
    this.usersService.getAppSettings(appType).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res.isSuccess && res.data) {
          this.originalData = {
            adminEmail: res.data.adminEmail || '',
            adminPhone: res.data.adminPhone || '',
            aboutText: res.data.aboutText || ''
          };
          this.currentData = { ...this.originalData };
        } else {
          // Defaults if no data
          this.originalData = { adminEmail: '', adminPhone: '', aboutText: '' };
          this.currentData = { ...this.originalData };
        }
      },
      error: (err: any) => {
        this.isLoading = false;
        this.toasterService.error(`Failed to load ${appType} app settings.`);
        this.originalData = { adminEmail: '', adminPhone: '', aboutText: '' };
        this.currentData = { ...this.originalData };
      }
    });
  }

  saveSettings() {
    // Only send fields that have actually changed, along with appType
    const payload: any = {
      appType: this.activeTab
    };

    let hasChanges = false;
    
    if (this.currentData.adminEmail !== this.originalData.adminEmail) {
      payload.adminEmail = this.currentData.adminEmail;
      hasChanges = true;
    }
    if (this.currentData.adminPhone !== this.originalData.adminPhone) {
      payload.adminPhone = this.currentData.adminPhone;
      hasChanges = true;
    }
    if (this.currentData.aboutText !== this.originalData.aboutText) {
      payload.aboutText = this.currentData.aboutText;
      hasChanges = true;
    }

    if (!hasChanges) {
      this.toasterService.success('No changes detected.');
      return;
    }

    this.isSaving = true;
    this.usersService.upsertAppSettings(payload).subscribe({
      next: (res: any) => {
        this.isSaving = false;
        if (res.isSuccess !== false) { // Treat no isSuccess property as success conceptually just in case
          this.toasterService.success(`${this.activeTab} app settings updated successfully.`);
          // Sync original data
          this.originalData = { ...this.currentData };
        } else {
           this.toasterService.error(res.message || 'Failed to update app settings.');
        }
      },
      error: (err: any) => {
        this.isSaving = false;
        this.toasterService.error('An error occurred while updating settings.');
      }
    });
  }

}
